import script from "./AccordianComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordianComponent.vue?vue&type=script&setup=true&lang=js"

import "./AccordianComponent.vue?vue&type=style&index=0&id=5f9314a1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f9314a1"]])

export default __exports__